import moment from 'moment';
import capitalize from 'lodash/capitalize';

const stringifyMinutesCount = (minutesCount, format: string = 'HH:mm'): string => {
  return moment().startOf('day').add(minutesCount, 'm').format(format);
};

const getWeekDayName = (weekday: number, format: string = 'dddd'): string => {
  return capitalize(moment().weekday(weekday).format(format));
};

const getMonthName = (month: number, format: string = 'MMMM'): string => {
  return capitalize(moment().month(month - 1).format(format));
};

const getDayName = (dayIndex: number): string => {
  return moment().startOf('w').add(dayIndex % 7, 'd').format('dddd');
};

const getGroupWeekdaysName = (): string => {
  return moment().day(1).format('ddd') + '-' + moment().day(5).format('ddd').toLowerCase();
};

const convertMinutesCountToTime = (minutesCount: number = 0, format: string = 'HH:mm'): Date => {
  return moment().hours(Math.floor(minutesCount / 60)).minutes(minutesCount % 60).toDate();
};

const getTomorrowDate = () => {
  return moment().add(1, 'days').toDate();
};

const addDaysToDate = (date: Date, days: number): Date => {
  return moment(date).add(days, 'days').toDate();
};

const convertDateToStr = (date: Date, format = 'YYYY-MM-DD'): any => {
  return moment(date).format(format);
};

export const dateHelper = {
  stringifyMinutesCount,
  getMonthName,
  getWeekDayName,
  getDayName,
  getGroupWeekdaysName,
  convertMinutesCountToTime,
  getTomorrowDate,
  addDaysToDate,
  convertDateToStr,
};
